'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
const AsyncSaveAsTemplateModal = Loadable({
  loader: () => import( /* webpackChunkName: "modal-actions" */'EmailComponents/SaveTemplateModal'),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncSaveAsTemplateModal;